// extracted by mini-css-extract-plugin
export default {"source_details_container":"source-details_source_details_container__3m0V-","header_container":"source-details_header_container__kz-Hk"};